var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2494 35.6546C11.0866 35.6546 11.7654 35.4001 11.7654 35.0861C11.7654 34.7721 11.0866 34.5176 10.2494 34.5176C9.41213 34.5176 8.7334 34.7721 8.7334 35.0861C8.7334 35.4001 9.41213 35.6546 10.2494 35.6546Z",
    fill: "url(#paint0_linear_1813_120727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8881 35.5784C14.7253 35.5784 15.4041 35.3239 15.4041 35.0099C15.4041 34.6959 14.7253 34.4414 13.8881 34.4414C13.0508 34.4414 12.3721 34.6959 12.3721 35.0099C12.3721 35.3239 13.0508 35.5784 13.8881 35.5784Z",
    fill: "url(#paint1_linear_1813_120727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7174 26.0239C20.1499 25.198 21.1011 24.164 20.8419 23.7142C20.5826 23.2645 19.2111 23.5694 17.7785 24.3953C16.3459 25.2211 15.3947 26.2552 15.654 26.7049C15.9133 27.1547 17.2848 26.8498 18.7174 26.0239Z",
    fill: "url(#paint2_linear_1813_120727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3717 28.0505C17.9014 24.786 15.6845 21.7102 12.42 21.1804C9.15559 20.6507 6.07977 22.8676 5.55002 26.1321C5.02027 29.3966 7.23719 32.4724 10.5017 33.0022C13.7661 33.5319 16.8419 31.315 17.3717 28.0505Z",
    fill: "url(#paint3_linear_1813_120727)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5516 31.7891H8.73242V35.0485H10.5516V31.7891Z",
    fill: "url(#paint4_linear_1813_120727)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1913 31.7891H12.3721V35.0485H14.1913V31.7891Z",
    fill: "url(#paint5_linear_1813_120727)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.613 27.6205C12.7433 27.6205 13.6596 26.7043 13.6596 25.5739C13.6596 24.4436 12.7433 23.5273 11.613 23.5273C10.4827 23.5273 9.56641 24.4436 9.56641 25.5739C9.56641 26.7043 10.4827 27.6205 11.613 27.6205Z",
    fill: "url(#paint6_linear_1813_120727)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6138 26.255C11.9906 26.255 12.296 25.9496 12.296 25.5728C12.296 25.1961 11.9906 24.8906 11.6138 24.8906C11.2371 24.8906 10.9316 25.1961 10.9316 25.5728C10.9316 25.9496 11.2371 26.255 11.6138 26.255Z",
    fill: "url(#paint7_linear_1813_120727)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65396 21.5211C5.17044 19.3557 6.71605 17.1676 9.10617 16.6339C11.4963 16.1002 13.8258 17.423 14.3093 19.5884C14.7929 21.7538 13.2088 22.5525 10.8187 23.0862C8.4286 23.6199 6.13747 23.6865 5.65396 21.5211Z",
    fill: "url(#paint8_linear_1813_120727)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42262 25.5938C7.64508 25.1248 6.61424 24.1701 5.12018 23.4615C3.62612 22.7529 2.23462 22.5587 2.01216 23.0277C1.78971 23.4967 2.82054 24.4514 4.3146 25.16C5.80866 25.8686 7.20017 26.0628 7.42262 25.5938Z",
    fill: "url(#paint9_linear_1813_120727)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52051 29.2501C8.52051 29.8362 10.0296 30.9935 11.7041 30.9935C13.3786 30.9935 14.9486 29.3435 14.9486 28.7574C14.9486 28.1713 13.3786 28.8711 11.7041 28.8711C10.0296 28.8711 8.52051 28.664 8.52051 29.2501Z",
    fill: "url(#paint10_linear_1813_120727)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3422 35.6546C33.1794 35.6546 33.8582 35.4001 33.8582 35.0861C33.8582 34.7721 33.1794 34.5176 32.3422 34.5176C31.5049 34.5176 30.8262 34.7721 30.8262 35.0861C30.8262 35.4001 31.5049 35.6546 32.3422 35.6546Z",
    fill: "url(#paint11_linear_1813_120727)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7035 35.5784C29.5407 35.5784 30.2195 35.3239 30.2195 35.0099C30.2195 34.6959 29.5407 34.4414 28.7035 34.4414C27.8662 34.4414 27.1875 34.6959 27.1875 35.0099C27.1875 35.3239 27.8662 35.5784 28.7035 35.5784Z",
    fill: "url(#paint12_linear_1813_120727)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9366 26.7057C27.1958 26.256 26.2447 25.2219 24.8121 24.396C23.3795 23.5702 22.008 23.2652 21.7487 23.715C21.4895 24.1647 22.4406 25.1988 23.8732 26.0247C25.3058 26.8505 26.6773 27.1554 26.9366 26.7057Z",
    fill: "url(#paint13_linear_1813_120727)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1288 33.078C34.4359 33.078 37.1169 30.397 37.1169 27.0898C37.1169 23.7826 34.4359 21.1016 31.1288 21.1016C27.8216 21.1016 25.1406 23.7826 25.1406 27.0898C25.1406 30.397 27.8216 33.078 31.1288 33.078Z",
    fill: "url(#paint14_linear_1813_120727)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8582 31.7891H32.0391V35.0485H33.8582V31.7891Z",
    fill: "url(#paint15_linear_1813_120727)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2196 31.7891H28.4004V35.0485H30.2196V31.7891Z",
    fill: "url(#paint16_linear_1813_120727)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7253 27.6205C30.8556 27.6205 31.7719 26.7043 31.7719 25.5739C31.7719 24.4436 30.8556 23.5273 29.7253 23.5273C28.595 23.5273 27.6787 24.4436 27.6787 25.5739C27.6787 26.7043 28.595 27.6205 29.7253 27.6205Z",
    fill: "url(#paint17_linear_1813_120727)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2334 25.7764C29.5007 25.5094 29.5024 25.0777 29.2372 24.8123C28.972 24.5469 28.5404 24.5482 28.2731 24.8153C28.0058 25.0823 28.004 25.514 28.2692 25.7794C28.5344 26.0448 28.9661 26.0435 29.2334 25.7764Z",
    fill: "url(#paint18_linear_1813_120727)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7729 23.0862C29.3828 22.5525 27.7987 21.7538 28.2823 19.5884C28.7658 17.423 31.0953 16.1002 33.4854 16.6339C35.8755 17.1676 37.4211 19.3557 36.9376 21.5211C36.4541 23.6865 34.163 23.6199 31.7729 23.0862Z",
    fill: "url(#paint19_linear_1813_120727)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3909 31.6517C37.8926 31.5185 37.9553 30.1149 37.5308 28.5167C37.1063 26.9185 36.3555 25.7309 35.8537 25.8642C35.352 25.9974 35.2894 27.4011 35.7139 28.9992C36.1384 30.5974 36.8892 31.785 37.3909 31.6517Z",
    fill: "url(#paint20_linear_1813_120727)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7727 28.8711C28.6734 28.8711 27.6426 28.1713 27.6426 28.7574C27.6426 29.3435 28.6733 30.9935 29.7727 30.9935C30.8721 30.9935 31.8628 29.8362 31.8628 29.2501C31.8628 28.664 30.8721 28.8711 29.7727 28.8711Z",
    fill: "url(#paint21_linear_1813_120727)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0335 17.1593H21.5017C21.0254 17.1588 20.5687 16.9693 20.2318 16.6324C19.8949 16.2956 19.7055 15.8389 19.7049 15.3625V14.916C19.7049 13.8102 19.9144 12.8843 20.3277 12.164C20.8285 11.3262 21.4128 10.5412 22.0716 9.82093C22.5089 9.38111 22.9058 8.90278 23.2573 8.39174C23.5095 7.99472 23.6397 7.53243 23.6318 7.06214C23.6318 5.95286 22.9091 5.41359 21.4223 5.41359C20.5976 5.42291 19.7781 5.54591 18.987 5.77912C18.6819 5.86621 18.3607 5.8813 18.0488 5.8232C17.7369 5.7651 17.4427 5.63541 17.1894 5.44431C16.9362 5.25322 16.7307 5.00595 16.5892 4.72196C16.4477 4.43798 16.3741 4.12502 16.374 3.80774V2.90396C16.3723 2.5149 16.4834 2.13368 16.694 1.80652C16.9046 1.47936 17.2055 1.2203 17.5604 1.06076C18.9576 0.464483 20.4644 0.16806 21.9833 0.190654C23.5745 0.190654 25.011 0.457945 26.2528 0.984991C27.497 1.51326 28.4799 2.25817 29.1743 3.19909C29.8666 4.13334 30.2346 5.26828 30.2221 6.43102C30.2221 7.67962 29.8812 8.76711 29.209 9.66329C28.544 10.5504 27.5908 11.5215 26.3759 12.5499C25.7357 13.0822 25.1291 13.6537 24.5595 14.261C24.1916 14.6573 23.9316 15.1414 23.8043 15.6669C23.7335 16.085 23.5166 16.4643 23.1924 16.7376C22.8682 17.0108 22.4576 17.1603 22.0335 17.1593Z",
    fill: "url(#paint22_linear_1813_120727)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.739 25.6117H21.6689C20.786 25.6111 19.9395 25.26 19.3155 24.6355C18.6914 24.011 18.3408 23.1643 18.3408 22.2814C18.3408 21.3986 18.6914 20.5518 19.3155 19.9273C19.9395 19.3029 20.786 18.9517 21.6689 18.9512H21.739C22.1765 18.9509 22.6098 19.0368 23.0141 19.2041C23.4184 19.3713 23.7857 19.6165 24.0952 19.9258C24.4047 20.2351 24.6502 20.6023 24.8177 21.0065C24.9852 21.4107 25.0714 21.8439 25.0714 22.2814C25.0714 22.7189 24.9852 23.1522 24.8177 23.5563C24.6502 23.9605 24.4047 24.3277 24.0952 24.637C23.7857 24.9463 23.4184 25.1915 23.0141 25.3588C22.6098 25.526 22.1765 25.6119 21.739 25.6117Z",
    fill: "url(#paint23_linear_1813_120727)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.381 35.7175H0.139042C0.102165 35.7175 0.0668017 35.7029 0.0407264 35.6768C0.014651 35.6507 0 35.6154 0 35.5785C0 35.5416 0.014651 35.5063 0.0407264 35.4802C0.0668017 35.4541 0.102165 35.4395 0.139042 35.4395H43.381C43.4179 35.4395 43.4532 35.4541 43.4793 35.4802C43.5054 35.5063 43.52 35.5416 43.52 35.5785C43.52 35.6154 43.5054 35.6507 43.4793 35.6768C43.4532 35.7029 43.4179 35.7175 43.381 35.7175Z",
    fill: "url(#paint24_linear_1813_120727)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51147 12.1694C9.00807 12.1694 9.41064 11.7669 9.41064 11.2703C9.41064 10.7737 9.00807 10.3711 8.51147 10.3711C8.01488 10.3711 7.6123 10.7737 7.6123 11.2703C7.6123 11.7669 8.01488 12.1694 8.51147 12.1694Z",
    fill: "url(#paint25_linear_1813_120727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_120727",
    x1: 5.56348,
    y1: 34.9435,
    x2: 11.8992,
    y2: 37.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1813_120727",
    x1: 9.20215,
    y1: 34.8673,
    x2: 15.5379,
    y2: 37.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1813_120727",
    x1: 10.1124,
    y1: 29.6275,
    x2: 23.0772,
    y2: 28.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1813_120727",
    x1: 7.01374,
    y1: 45.1212,
    x2: 15.4079,
    y2: 18.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1813_120727",
    x1: 6.83047,
    y1: 33.0101,
    x2: 11.1444,
    y2: 33.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1813_120727",
    x1: 10.4701,
    y1: 33.0101,
    x2: 14.784,
    y2: 33.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1813_120727",
    x1: 5.28701,
    y1: 25.0607,
    x2: 14.8626,
    y2: 26.4132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1813_120727",
    x1: 9.50517,
    y1: 25.4018,
    x2: 12.697,
    y2: 25.8526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1813_120727",
    x1: -3.66719,
    y1: 19.0944,
    x2: 16.734,
    y2: 22.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1813_120727",
    x1: 2.794,
    y1: 26.6141,
    x2: 4.89176,
    y2: 22.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1813_120727",
    x1: 1.79993,
    y1: 29.4488,
    x2: 15.3122,
    y2: 34.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1813_120727",
    x1: 27.6563,
    y1: 34.9435,
    x2: 33.992,
    y2: 37.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1813_120727",
    x1: 24.0176,
    y1: 34.8673,
    x2: 30.3533,
    y2: 37.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1813_120727",
    x1: 22.2412,
    y1: 27.3524,
    x2: 24.649,
    y2: 23.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1813_120727",
    x1: 12.6194,
    y1: 25.5881,
    x2: 40.6368,
    y2: 29.5453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1813_120727",
    x1: 30.1371,
    y1: 33.0101,
    x2: 34.451,
    y2: 33.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1813_120727",
    x1: 26.4984,
    y1: 33.0101,
    x2: 30.8123,
    y2: 33.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1813_120727",
    x1: 23.3993,
    y1: 25.0607,
    x2: 32.9749,
    y2: 26.4132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1813_120727",
    x1: 27.1368,
    y1: 26.67,
    x2: 29.7224,
    y2: 24.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1813_120727",
    x1: 18.9627,
    y1: 19.0944,
    x2: 39.3639,
    y2: 22.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1813_120727",
    x1: 33.6216,
    y1: 28.7781,
    x2: 37.9993,
    y2: 27.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1813_120727",
    x1: 23.2304,
    y1: 29.4488,
    x2: 32.7459,
    y2: 31.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1813_120727",
    x1: 1.89557,
    y1: 6.54665,
    x2: 34.5056,
    y2: 10.3053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1813_120727",
    x1: 11.3041,
    y1: 21.4463,
    x2: 27.043,
    y2: 23.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1813_120727",
    x1: -45.5,
    y1: 35.5436,
    x2: -45.2879,
    y2: 40.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1813_120727",
    x1: 5.73215,
    y1: 11.0448,
    x2: 9.93918,
    y2: 11.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqSectionIcon);
export default __webpack_public_path__ + "static/media/faq-section-icon.318bc8217d6c18211aae5934f1c505f3.svg";
export { ForwardRef as ReactComponent };